import { useContext, useEffect, useState } from "react";
import { LoaderContext } from "../../../../context/LoaderContext";
import { START_LOADER, STOP_LOADER } from "../../../../constants";
import CustomTooltip from "../../../../components/CustomToolTip/CustomTooltip";
import { UilSync, UilInfoCircle } from '@iconscout/react-unicons';
import Typography from "../../../../components/Typography/Typography";
import Table from "../../../../components/Table/Table";
import classes from '../../../../styles/AllDevices.module.css';
import monitoringClasses from './index.module.css';
import { EventsService } from "../../../../services/EventsService";
import { AdminService } from "../../../../services/AdminService";
import { DropdownComponent } from "../../../../components/Inputs/Input";
import { momentTimeFormater } from "../../../../utils/timeHelper";

const defaultValue = {
    label: 'All',
    value: 'all',
};

const OverviewEvents = ({ admins, updateQueryParams, queryParamsData }) => {
    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });
    const [events, setEvents] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState({});
    const [selectedCustomer, setSelectedCustomer] = useState(
        queryParamsData.customer
            ? JSON.parse(queryParamsData.customer)
            : defaultValue
    );
    const [customers, setCustomers] = useState([defaultValue]);

    useEffect(() => {
        if (selectedCustomer?.value) {
            getEvents();
        }
    }, [selectedCustomer?.value]);

    useEffect(() => {
        setSelectedAdmin(queryParamsData.admin ? JSON.parse(queryParamsData.admin) : admins[0]);
    }, [admins]);

    useEffect(() => {
        if (selectedAdmin?.value && selectedAdmin?.value !== 'all') {
            getCustomers();
        } else if (selectedAdmin?.value === 'all') {
            setSelectedCustomer(defaultValue);
            setCustomers([defaultValue]);
        }
    }, [selectedAdmin]);

    const getCustomers = () => {
        AdminService.GetCustomers(selectedAdmin?.value, startLoader, handleGetCustomerSuccess, handleError, stopLoader);
    };

    const handleGetCustomerSuccess = ({ data }) => {
        let temp = [
            {
                label: 'All',
                value: 'all',
            },
        ];
        data.data.map((c) => {
            temp.push({
                label: c.name,
                value: c._id,
            });
        });
        setCustomers(temp);
    };

    const getEvents = () => {
        EventsService.GetOverviewEvents(
            {
                customerId: selectedCustomer.value
            },
            () => startLoader('GetOverviewEvents'),
            handleGetEventsSuccess,
            handleError,
            () => stopLoader('GetOverviewEvents')
        );
    };

    const handleError = (err) => {
        console.log(err);
    };

    const handleGetEventsSuccess = ({ data }) => {
        const processedData = data?.data?.data?.map((item, index) => {
            return {
                's.no': index + 1,
                customerName: item.customerName,
                instanceName: item.instanceName,
                edgeId: item.edgeId,
                bidStatus: item.bidStatus || '--',
                currentSOC: item.currentSOC ?? '--',
                power: item.power ?? '--',
                marketType: (
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4vw' }}>
                        {item.marketType || '--'}
                        {item.market?.length > 0 && (
                            <CustomTooltip content={item.market.join(', ')}>
                                <UilInfoCircle size={'1.2vw'} style={{ color: 'var(--color-primary)', cursor: 'pointer' }} />
                            </CustomTooltip>
                        )}
                    </span>
                ),
                isNextSlotAvailable: item.isNextSlotAvailable ? 'Yes' : 'No',
                lastReported: item.lastReportedTime ? momentTimeFormater(item.lastReportedTime).format('YYYY-MM-DD HH:mm:ss') : 'Offline',
            };
        });
        setEvents(processedData);
    };

    return (
        <div >
            <div className={monitoringClasses.Filter}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className={monitoringClasses.FilterContainer}>
                        <div>
                            <div className={classes.FieldControl}>
                                <label>Select Admin</label>
                                <DropdownComponent
                                    name="adminId"
                                    options={admins}
                                    defaultValue={selectedAdmin}
                                    onChange={(e) => {
                                        setSelectedAdmin(e);
                                        updateQueryParams('admin', JSON.stringify(e));
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <div className={classes.FieldControl}>
                                <label>Select Customer</label>
                                <DropdownComponent
                                    name="customerId"
                                    options={customers}
                                    defaultValue={selectedCustomer}
                                    onChange={(e) => {
                                        if (e.value !== selectedCustomer?.value) {
                                            setSelectedCustomer(e);
                                        }
                                        updateQueryParams('customer', JSON.stringify(e));
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={monitoringClasses.FilterContainer}>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1vw', alignItems: 'flex-end' }}>
                        <div onClick={() => {
                            getEvents();
                        }}>
                            <CustomTooltip content={'Refresh'}>
                                <UilSync size={'1.2vw'} style={{ color: 'var(--color-primary)', cursor: 'pointer' }} />
                            </CustomTooltip>
                        </div>
                    </div>
                </div>

            </div>
            <div className={classes.AllDevices}>
                <div className={classes.Header}>
                    <div>
                        <Typography content={`Overview`} />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={events.length} />
                            </span>
                        </div>
                    </div>
                </div>
                <Table
                    head={[
                        'Customer',
                        'Instance',
                        'Edge ID',
                        (<div>
                            <CustomTooltip content={'Status only denotes energy markets'}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.3vw' }}>
                                    <div>Bid Status</div>
                                    <UilInfoCircle size="1vw" />
                                </div>
                            </CustomTooltip>
                        </div>),
                        'Current SOC',
                        'Power',
                        'Market Type',
                        'Next Slot Available',
                        'Last Reported (CET)',
                    ]}
                    keys={[
                        'customerName',
                        'instanceName',
                        'edgeId',
                        'bidStatus',
                        'currentSOC',
                        'power',
                        'marketType',
                        'isNextSlotAvailable',
                        'lastReported',
                    ]}
                    data={events}
                />
            </div>
        </div>
    )
}

export default OverviewEvents;